import { useEffect } from "react";
import { useChannelStateContext } from "stream-chat-react";

interface ThreadDetectorProps {
  onThreadChange: (open: boolean) => void;
}

/**
 * Bridge component placed inside <Channel> that detects when a thread is
 * opened or closed and bubbles the state up to the parent via callback.
 */
export const ThreadDetector = ({ onThreadChange }: ThreadDetectorProps) => {
  const { thread } = useChannelStateContext();

  useEffect(() => {
    onThreadChange(!!thread);
  }, [thread, onThreadChange]);

  return null;
};
